import Rx from 'rxjs';
import { push } from 'react-router-redux';
import { combineEpics } from 'redux-observable';
import { change as changeFieldValue } from 'redux-form';

import * as constAction from 'root/actionConstants';
import * as generalFunctions from 'core/generalFunctions';
import * as generalActions from 'modules/general/action';

export const contrasenaCambiadaEpic = action$ => action$.ofType(constAction.CONTRASENA_CAMBIADA).mapTo(push('/notificacion'));

export const redirectLoginEpic = action$ =>
  action$.ofType(constAction.USER_ROLES_SET_STATE).mergeMap(action => {
    let currentPath = generalFunctions.getCurrentPath();
    if (action.payload.roles && (currentPath == '/dashboard' || currentPath == '/')) {
      return Rx.Observable.of(push('/dashboard/reservas/main/hoy'));
    } else return Rx.Observable.empty();
  });

export const initSocketsEpic = (action$, store) =>
  action$
    .ofType(constAction.SOCKETS_GENERAL_START)
    .switchMap(action => {
      const socketConnection = new generalFunctions.SocketConnection(),
        storeState = store.getState(),
        accessToken = storeState.getIn(['user', 'access_token']),
        userId = storeState.getIn(['user', 'userId']);
      if (!accessToken) Rx.Observable.empty();
      return Rx.Observable.merge(
        socketConnection.listen$('connect').switchMap(() => {
          return Rx.Observable.of(socketConnection.emitter('authentication', { accessToken, userId }))
            .delay(1000)
            .switchMap(() => Rx.Observable.of(socketConnection.emitter('join', { method: 'viajesAll', accessToken })))
            .switchMap(() => Rx.Observable.of(socketConnection.emitter('join', { method: 'logs', accessToken })))
            .switchMap(() => Rx.Observable.of(socketConnection.emitter('join', { method: 'registros', accessToken })))
            .switchMap(() => Rx.Observable.of(socketConnection.emitter('join', { method: 'localizacionAll', accessToken })))
            .delay(1000)
            .switchMap(() =>
              Rx.Observable.merge(
                socketConnection.listen$('viajesAll').map(data => generalActions.socketData(constAction.VIAJES_SOCKET_DATA, data)),
                socketConnection.listen$('logs').map(data => generalActions.socketData(constAction.REGISTROS_LOGS_CONCAT_STATE, data)),
                socketConnection.listen$('registros').map(data => generalActions.socketData(constAction.REGISTROS_SOCKET_DATA, data)),
                socketConnection.listen$('localizacionAll').map(data => generalActions.socketData(constAction.VIAJESLOC_SOCKET_DATA, data)),
              ),
            );
        }),
        socketConnection
          .listen$('disconnect')
          .delay(3000)
          .switchMap(() => Rx.Observable.of(action)),
      );
    })
    .catch(() => Rx.Observable.empty());

export const reverseGeoEpic = action$ =>
  action$
    .ofType(constAction.REVERSE_GEOCODING)
    .debounceTime(1000)
    .switchMap(action => {
      const { formName, latLng, fieldName } = action.payload;

      if (!window.google || !window.google.maps) return Rx.Observable.empty();
      let geocoder = new window.google.maps.Geocoder();

      return Rx.Observable.create(observer => {
        geocoder.geocode(
          {
            location: latLng,
            bounds: new window.google.maps.LatLngBounds(new window.google.maps.LatLng(latLng.lat, latLng.lng), new window.google.maps.LatLng(latLng.lat, latLng.lng)),
          },
          (res, status) => {
            if (status == 'OK' && res && res[0]) {
              let finalParada = '',
                paradaObject = {};

              for (let index in res) {
                if (res[index] && res[index].types && res[index].types.some(r => ['bus_station', 'street_address'].indexOf(r) >= 0)) {
                  if (res[index].address_components) {
                    res[index].address_components.map(comp => {
                      if (comp.types) {
                        if (comp.types.includes('street_number')) paradaObject.numero = comp.long_name;
                        else if (comp.types.some(r => ['bus_station', 'route'].indexOf(r) >= 0)) paradaObject.nombre = comp.short_name;
                        else if (comp.types.includes('sublocality')) paradaObject.subLocalidad = comp.long_name;
                        else if (comp.types.includes('locality')) paradaObject.localidad = comp.long_name;
                        else if (comp.types.includes('administrative_area_level_1')) paradaObject.provincia = comp.long_name;
                      }
                    });
                    if (paradaObject.nombre) {
                      finalParada = paradaObject.nombre;
                      if (paradaObject.numero && paradaObject.numero != 's/n') finalParada += ' ' + paradaObject.numero;
                      if (paradaObject.localidad) finalParada += ', ' + paradaObject.localidad;
                      else if (paradaObject.subLocalidad) finalParada += ', ' + paradaObject.subLocalidad;
                    }
                  }
                  if (!finalParada) finalParada = res[index].formatted_address.substr(0, res[index].formatted_address.indexOf(','));
                  break;
                }
              }

              finalParada = (finalParada || res[0].formatted_address || '').replace(',,', ',');
              observer.next(finalParada);
            } else observer.error('Ha ocurrido un error.');
          },
        );
        return () => {
          observer.complete();
        };
      })
        .map(res => changeFieldValue(formName, fieldName, res))
        .catch(error => {
          console.log('error', error);
          return Rx.Observable.empty();
        });
    });

export default combineEpics(contrasenaCambiadaEpic, redirectLoginEpic, initSocketsEpic, reverseGeoEpic);



// WEBPACK FOOTER //
// src/modules/general/epics.js